"use client";

import { LeadLoader, PageNotFoundLoader, DataNotFoundLoader, DefaultLoader, InitialLoader } from "@grudder/components/Common/Loaders";
import { createTheme, Loader, MantineProvider, Select, TextInput } from "@mantine/core";
import { ReactNode } from "react";

export default function Mantine({ children }: { children: ReactNode }) {
  const grPrimary = [
    "#dcf2f0", // 50
    "#a8dfd8", // 100
    "#6bcac0", // 200
    "#00b5a5", // 300
    "#00a593", // 400
    "#009480", // 500
    "#008773", // 600
    "#007763", // 700
    "#006754", // 800
    "#004b37", // 900
  ] as const;

  const theme = createTheme({
    colors: {
      "gr-primary": grPrimary,
    },
    primaryColor: "gr-primary",
    //primaryShade: { light: 3, dark: 6 }, // 300 for light mode, 600 for dark mode

    components: {
      Loader: Loader.extend({
        defaultProps: {
          loaders: {
            ...Loader.defaultLoaders,
            "gr-loader": DefaultLoader,
            "gr-lead-loader": LeadLoader,
            "gr-initial-loader": InitialLoader,
            "gr-page-not-found": PageNotFoundLoader,
            "gr-data-not-found": DataNotFoundLoader,
            "gr-webhook-logs-loader": DefaultLoader,
          },
        },
      }),
      Button: {
        defaultProps: {
          size: "md",
        },
        styles: () => ({
          root: {
            height: "40px",
            borderRadius: "8px",
          },
        }),
      },
      Input: {
        defaultProps: {
          size: "md",
        },
        styles: () => ({
          input: {
            height: "40px",
            borderRadius: "8px",
          },
        }),
      },
      TextInput: TextInput.extend({
        defaultProps: {
          size: "md",
        },
        styles: () => ({
          input: {
            height: "40px",
            borderRadius: "8px",
          },
        }),
      }),
      // TextInput: {
      //   defaultProps: {
      //     size: "md",
      //   },
      //   styles: () => ({
      //     input: {
      //       height: "40px",
      //       borderRadius: "8px",
      //     },
      //   }),
      // },
      Select:Select.extend({
        defaultProps: {
          size: "md",
        },
        styles: () => ({
          input: {
            height: "40px",
            borderRadius: "8px",
          },
        }),
      }),
      PasswordInput: {
        defaultProps: {
          size: "md",
        },
        styles: () => ({
          input: {
            height: "40px",
            borderRadius: "8px",
          },
        }),
      },
      Chip: {},
      Drawer: {
        defaultProps: {
          size: "md",
        },
      },
    },
  });

  return <MantineProvider theme={theme}>{children}</MantineProvider>;
}
